/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_Cadence_RunningInputs */

const en_ui_chart_series_cadence_running = /** @type {(inputs: Ui_Chart_Series_Cadence_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadence (spm)`)
};

const de_ui_chart_series_cadence_running = /** @type {(inputs: Ui_Chart_Series_Cadence_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadenz (spm)`)
};

/**
* | output |
* | --- |
* | "Cadence (spm)" |
*
* @param {Ui_Chart_Series_Cadence_RunningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_cadence_running = /** @type {((inputs?: Ui_Chart_Series_Cadence_RunningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_Cadence_RunningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_cadence_running(inputs)
	return de_ui_chart_series_cadence_running(inputs)
});